/**
 * A commodity method's answer along each price path, beside its headline.
 *
 * Each row is a full revaluation, not a slope: the price deck as entered, spot held
 * flat, the forward curve, the long-term price throughout, and the deck lower and
 * higher. Shown as a table because the long-term price is most of a miner's value, and
 * one price's answer read on its own carries an authority it has not earned.
 */

export interface PriceScenario {
  name: string;
  equityValue: number;
  perShare?: number | null;
}

export default function PriceScenarios({
  scenarios,
  format,
}: {
  scenarios: PriceScenario[] | undefined;
  format: (value: number) => string;
}) {
  if (!scenarios || scenarios.length === 0) return null;
  return (
    <table className="mt-2 border-collapse text-xs" aria-label="Value by price scenario">
      <tbody>
        {scenarios.map((scenario) => (
          <tr key={scenario.name} className="border-t border-gray-100 first:border-t-0">
            <td className="py-0.5 pr-4 text-gray-600">{scenario.name}</td>
            <td className="py-0.5 text-right tabular-nums text-gray-900">
              {format(scenario.equityValue)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
